import { render, staticRenderFns } from "./CPInput.vue?vue&type=template&id=b60ae74c&scoped=true"
import script from "./CPInput.vue?vue&type=script&lang=js"
export * from "./CPInput.vue?vue&type=script&lang=js"
import style0 from "./CPInput.vue?vue&type=style&index=0&id=b60ae74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60ae74c",
  null
  
)

export default component.exports